import {
  Stack,
  Tooltip,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { AlertInfoIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import messages from '../messages';
import type { Props } from './types';

function ScreeningDetailsTooltip({ intl, details }: Props) {
  return (
    <Tooltip
      placement="left"
      variant="light"
      arrow={true}
      title={details}
      containerSX={{
        visibility: details ? 'visible' : 'hidden',
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={0.5}
        paddingX={0.5}
        paddingY={1}
        sx={{
          '&:hover': {
            backgroundColor: 'action.hover',
            borderRadius: '4px',
          },
        }}
      >
        <AlertInfoIcon fontSize="xSmall" />
        <Typography
          variant="labelSmall"
          color="text.secondary"
          sx={{
            marginTop: '1px !important',
          }}
        >
          {intl.formatMessage(messages.details)}
        </Typography>
      </Stack>
    </Tooltip>
  );
}

export default ScreeningDetailsTooltip;
